export default __webpack_public_path__ + "static/media/portfolio-cregar-5.e9760627.jpg";